const audioPlayers: Record<string, any> = {};

export const registerAudioPlayer = (id: string, wavesurfer: any) => {
    audioPlayers[id] = wavesurfer;
};

export const unregisterAudioPlayer = (id: string) => {
    delete audioPlayers[id];
};

export const clearAllAudioPlayers = () => {
    Object.values(audioPlayers).forEach(player => player?.destroy?.());
    for (const key in audioPlayers) {
        delete audioPlayers[key];
    }
};

export const getAllAudioPlayers = () => audioPlayers;